import { render, staticRenderFns } from "./OtherUserSafetyConfirmAnswerTable.vue?vue&type=template&id=a308d02a&lang=pug"
import script from "./OtherUserSafetyConfirmAnswerTable.vue?vue&type=script&lang=ts"
export * from "./OtherUserSafetyConfirmAnswerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports